import { Slot } from '@radix-ui/react-slot';
import { ReactNode, useContext, useEffect } from 'react';
import { FileViewerContext } from './_file_viewer.context';
import type { FileWorkerStaleDuckType } from './_file_worker_stale_duck_type';

export interface FileViewerItemProps {
	file: FileWorkerStaleDuckType;
	children?: ReactNode;
	/**
	 * Merges its props onto its immediate child.
	 */
	asChild?: boolean;
}

export function CellulaFileViewerItem({ file, children, asChild }: FileViewerItemProps): JSX.Element | null {
	const { files, setFiles, setIsOpen, setStartIndex } = useContext(FileViewerContext);
	const Comp = asChild ? Slot : 'div';

	useEffect(() => {
		setFiles((files) => [...files, file]);

		return () => {
			setFiles((files) => files.filter((x) => x.id !== file.id));
		};
	}, [file, setFiles]);

	function openFileViewer(): void {
		setIsOpen(true);
		setStartIndex(files.findIndex((x) => x.id === file.id));
	}

	function handleClick(): void {
		openFileViewer();
	}

	function handleKeyDown(event: React.KeyboardEvent<HTMLDivElement>): void {
		if (event.key === 'Space') {
			openFileViewer();
		}
	}

	if (children === undefined) {
		return null;
	}

	return (
		<Comp onClick={handleClick} onKeyDown={handleKeyDown} tabIndex={0} role='button'>
			{children}
		</Comp>
	);
}
